document.addEventListener("DOMContentLoaded", () => {
  class MobileSelectorModal extends HTMLElement {
    constructor() {
      super();
      this.selectedValue = null;
      this.els = {};
      this.options = {};

      // 原始 DOM 隐藏
      this.style.display = "none";

      // 创建 portal
      this.portalContainer = document.createElement("div");
      this.portalContainer.style.position = "fixed";
      this.portalContainer.style.top = "0";
      this.portalContainer.style.left = "0";
      this.portalContainer.style.width = "100%";
      this.portalContainer.style.height = "100%";
      this.portalContainer.style.zIndex = "9999";
      this.portalContainer.style.display = "none";
      this.portalContainer.style.background = "rgba(0, 0, 0, 0.10)"
      document.body.appendChild(this.portalContainer);

      const content = this.innerHTML;
      this.portalContainer.innerHTML = content;
    }

    connectedCallback() {
      // 获取 class 配置
      const wrapperClass = this.getAttribute("wrapper-class") || "";
      const listsClass = this.getAttribute("lists-class") || "";
      const confirmClass = this.getAttribute("confirm-class") || "";
      const cancelClass = this.getAttribute("cancel-class") || "";
      const optionClass = this.getAttribute("option-class") || "";
      const highlightClass = this.getAttribute("selected-highlight") || "";

      const singleClassMap = {
        wrapper: wrapperClass,
        lists: listsClass,
        confirm: confirmClass,
        cancel: cancelClass,
        highlight: highlightClass,
      };

      this.els = Object.fromEntries(
        Object.entries(singleClassMap).map(([key, cls]) => [key, cls && this.portalContainer.querySelector(`.${cls}`)])
      );

      this.els.options = optionClass ? this.portalContainer.querySelectorAll(`.${optionClass}`) : null;

      if (Object.values(this.els).some((el) => !el) || !this.els.options || this.els.options.length === 0) {
        console.error("modal selector element is required");
        return;
      }

      // 等 slot 渲染完毕再绑定
      requestAnimationFrame(() => {
        // option click
        this.els.options.forEach((el, index) => {
          const v = this.getValueByEl(el);
          if (index === 0) {
            this.els.firstOption = el;
          }
          if (index === this.els.options.length - 1) {
            this.els.lastOption = el;
          }
          this.options[v] = {
            el: el,
          };
        });

        this.els.wrapper.style.position = "relative";
        this.els.lists.style.overflowY = "auto";
        this.els.lists.style.height = "100%";

        this.els.highlight.style.position = "absolute";
        this.els.highlight.style.top = "50%";
        this.els.highlight.style.transform = "translateY(-50%)";
        this.els.highlight.style.zIndex = "-1";

        // confirm
        this.els.confirm.addEventListener("click", () => this.confirm());

        // cancel
        this.els.cancel.addEventListener("click", () => this.cancel());

        this.bindScrollEnd();
      });
    }

    bindScrollEnd() {
      let timer = null;

      this.els.lists.addEventListener("scroll", () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const v = this.calcNearstOption();
          this.selectedValue = v;
          this.scrollToSelectedValue(v);
        }, 100);
      });

      this.els.lists.addEventListener("touchend", () => {
        clearTimeout(timer);
        const v = this.calcNearstOption();
        this.selectedValue = v;
        this.scrollToSelectedValue(v);
      });
    }

    open(selectedValue) {
      this.selectedValue = selectedValue;
      document.body.style.overflow = "hidden";
      this.portalContainer.style.display = "block";
      let allOptionsHeight = 0;
      Object.keys(this.options).forEach((v) => {
        this.options[v].height = this.options[v].el.offsetHeight;
        allOptionsHeight = allOptionsHeight + this.options[v].el.offsetHeight;
      });
      this.els.wrapper.style.height = `${allOptionsHeight}px`;
      this.els.wrapper.style.minHeight = `${100}px`;
      this.els.firstOption.style.marginTop = `${allOptionsHeight * 0.5}px`;
      this.els.lastOption.style.marginBottom = `${allOptionsHeight * 0.5}px`;
      const styles = getComputedStyle(this.els.wrapper);
      const paddingLeft = parseFloat(styles.paddingLeft);
      const paddingRight = parseFloat(styles.paddingRight);
      this.els.highlight.style.width = `${this.els.wrapper.clientWidth - paddingLeft - paddingRight}px`;
      this.scrollToSelectedValue(selectedValue);
    }

    close() {
      this.portalContainer.style.display = "none";
      document.body.style.overflow = "";
    }

    confirm() {
      this.dispatchEvent(
        new CustomEvent("confirm", {
          detail: { value: this.selectedValue },
          bubbles: true,
          composed: true,
        })
      );
      this.close();
    }

    cancel() {
      this.dispatchEvent(new CustomEvent("cancel", { bubbles: true, composed: true }));
      this.close();
    }

    disconnectedCallback() {
      if (this.portalContainer.parentNode) {
        this.portalContainer.parentNode.removeChild(this.portalContainer);
      }
    }

    getValueByEl(el) {
      return el.dataset.value;
    }

    calcNearstOption() {
      const tipRect = this.els.highlight.getBoundingClientRect();
      const tipCenterY = tipRect.top + tipRect.height / 2;

      let nearestItem = null;
      let minDistance = Infinity;

      this.els.options.forEach((li) => {
        const rect = li.getBoundingClientRect();
        const liCenterY = rect.top + rect.height / 2;
        const distance = Math.abs(liCenterY - tipCenterY);

        if (distance < minDistance) {
          minDistance = distance;
          nearestItem = li;
        }
      });

      if (!nearestItem) return;

      return this.getValueByEl(nearestItem);
    }

    scrollToSelectedValue(selectedValue) {
      const selectedOption = this.options[selectedValue];
      this.els.highlight.style.height = `${selectedOption.height}px`;

      const tipRect = this.els.highlight.getBoundingClientRect();
      const tipCenterY = tipRect.top + tipRect.height / 2;
      const liRect = selectedOption.el.getBoundingClientRect();
      const liCenterY = liRect.top + liRect.height / 2;

      const delta = liCenterY - tipCenterY;

      this.els.lists.scrollBy({
        top: delta,
        behavior: "smooth",
      });
    }
  }

  customElements.define("mobile-selector-modal", MobileSelectorModal);
});
